import gql from 'graphql-tag'

export default gql`
    query getPushes {
        getPushes {
            UserID
            ID
            Type
            Status
            EmailAddress
            DateCreated
            DateSent
            Title
            CampaignID
        }
    }
`
